var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c(
        "el-checkbox-group",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getReadMode(),
              expression: "!getReadMode()",
            },
          ],
          ref: "fieldEditor",
          attrs: {
            disabled: _vm.field.options.disabled,
            size: _vm.field.options.size,
          },
          on: { change: _vm.handleChangeEvent },
          model: {
            value: _vm.fieldModel,
            callback: function ($$v) {
              _vm.fieldModel = $$v
            },
            expression: "fieldModel",
          },
        },
        [
          !!_vm.field.options.buttonStyle
            ? _vm._l(_vm.field.options.optionItems, function (item, index) {
                return _c(
                  "el-checkbox-button",
                  {
                    key: index,
                    style: { display: _vm.field.options.displayStyle },
                    attrs: {
                      label: item[_vm.field.options.valueName] || item.value,
                      disabled: item.disabled,
                      border: _vm.field.options.border,
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(item[_vm.field.options.labelName] || item.name)
                    ),
                  ]
                )
              })
            : _vm._l(_vm.field.options.optionItems, function (item, index) {
                return _c(
                  "el-checkbox",
                  {
                    key: index,
                    style: { display: _vm.field.options.displayStyle },
                    attrs: {
                      label: item[_vm.field.options.valueName] || item.value,
                      disabled: item.disabled,
                      border: _vm.field.options.border,
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(item[_vm.field.options.labelName] || item.name)
                    ),
                  ]
                )
              }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.getReadMode()
        ? [
            _c("div", { staticClass: "readonly-mode-field" }, [
              _vm._v(_vm._s(_vm.contentForReadMode || "--")),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }